import { useCallback } from 'react';

import {
	useRouteActions,
	createSingleQueryParamHook,
} from '@confluence/route-manager/entry-points/RouteState.ts';
import { createEditDraftPageUrl } from '@confluence/content-utils/entry-points/newContentUrl.ts';
import { expValEquals } from '@confluence/feature-experiments';

import type { ResponseContentMetadata } from '../services/DocImportService.ts';

const getJiraIssueKeyParam = createSingleQueryParamHook('importGDoc');

export const useGoToDraftPage = (): ((pageData: ResponseContentMetadata | null) => void) => {
	const { push } = useRouteActions();
	const remoteIssueKey = getJiraIssueKeyParam();
	return useCallback(
		(pageData: ResponseContentMetadata | null) => {
			if (!pageData) {
				return;
			}
			const importedPageUrl = createEditDraftPageUrl(pageData);
			/**
			 * Experiment: after successfully importing a Google doc as a live page,
			 * let LivePageComponent handle creating the remote link to the issue the
			 * user originally cross flowed from.
			 */
			if (remoteIssueKey && expValEquals('cc_fd_jira_issue_live_doc_prompt', 'isEnabled', true)) {
				push(
					`${importedPageUrl}${importedPageUrl.includes('?') ? '&' : '?'}remoteIssueKey=${remoteIssueKey}`,
				);
			} else {
				push(`${importedPageUrl}${importedPageUrl.includes('?') ? '&' : '?'}importSurvey=true`);
			}
		},
		[push, remoteIssueKey],
	);
};
